export class InCompletedHoursViolation {
  type: string;
  startTime: string;
  inTime: number;
  reason: string;
  outTime: number;
  totalCompletedHours: number;
  inCompletedHours: number;
}

export class StartTimeViolation {
  type: string;
  startTime: string;
  inTime: number;
  reason: string;
}

export class ViolationModel {
  violatedDate: Date;
  reportingTo: any;
  // isResolved: boolean;
  // isEscalated: boolean;
  startTime: any;
  status: string;
  userProfileId: any;
  violations: any[];
  resolvedBy: any;
  resolvedDate: Date;
  objectId: string;
}